module.exports = __webpack_public_path__ + "static/background2-6ce940af70bcd821b3901081f743f314.jpg";